module.exports = __webpack_public_path__ + "img/gzherweima.05f93010.jpg";